import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * NOTE: DO NOT EDIT THIS FILE!!! THIS FILE WAS GENERATED USING THE FOLLOWING COMMAND.
 *
 * `nx generate @miro-site/local-plugins:update-ds-icons`
 */
import React from 'react';
import addPropsToSVG from '../utils/addPropsToSVG';
import { jsx as _jsx } from "react/jsx-runtime";

var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: props.strokeWidth || 1.5,
      d: "m14.5 6-6 6 6 6",
      vectorEffect: "non-scaling-stroke"
    })
  }));
};

export default addPropsToSVG(ChevronLeft);